<template>
    <div v-if="loading" class="text-center pa-4">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
        <p class="mt-2">loading statistics...</p>
    </div>
    
    <div v-else>
        <!-- 显示统计信息摘要 -->
        <v-row>
            <v-col md="12" sm="12">
            <v-card variant="outlined" title="" subtitle="">
                <div id="time" style="height:400px;" ></div>
            </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6" sm="12" xs="12">
                <v-card variant="outlined" title="" subtitle="">
                    <div id="main" style="height:400px;"></div>
                </v-card>
            </v-col>
            <v-col cols="12" md="6" sm="12" xs="12">
                <v-card variant="outlined" title="" subtitle="">
                    <div class="map-container">
                        <div id="main2"></div>
                    </div>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            content: '',
            userStatsData: null,
            sessionStatsData: null,
            timeSeriesData: null,
            loading: false,
        };
    },
    computed: {
        totalSessions() {
            if (this.timeSeriesData && this.timeSeriesData.data) {
                return this.timeSeriesData.data.reduce((total, item) => total + item.session_count, 0);
            }
            return 0;
        },
        totalUsers() {
            // 优先使用后端提供的 total_users；若缺失，则回退到求和
            if (this.userStatsData && typeof this.userStatsData.total_users === 'number') {
                return this.userStatsData.total_users;
            }
            if (this.userStatsData && this.userStatsData.data) {
                return this.userStatsData.data.reduce((total, item) => total + (Number(item.user_count ?? item.count) || 0), 0);
            }
            return 0;
        }
    },
    methods: {
        // 合并台湾数据到中国的辅助函数
        mergeTaiwanToChina(dataList, countryField = 'country', valueField = 'user_count') {
            const taiwanNames = ['Taiwan', 'Taiwan, China', 'Chinese Taipei', 'Taiwan Province of China', 'Republic of China'];
            const chinaNames = ['China', 'People\'s Republic of China', 'PRC'];

            let chinaIndex = -1;
            let taiwanIndices = [];

            // 找到中国和台湾的索引
            dataList.forEach((item, index) => {
                const countryName = item[countryField];
                if (chinaNames.some(name => countryName === name)) {
                    chinaIndex = index;
                } else if (taiwanNames.some(name => countryName === name)) {
                    taiwanIndices.push(index);
                }
            });

            // 如果找到台湾数据
            if (taiwanIndices.length > 0) {
                // 累加台湾的数值
                let taiwanTotal = 0;
                taiwanIndices.forEach(idx => {
                    const val = dataList[idx][valueField] || dataList[idx].value || dataList[idx].session_count || 0;
                    taiwanTotal += Number(val) || 0;
                });

                // 如果存在中国数据，合并到中国
                if (chinaIndex !== -1) {
                    const currentValue = dataList[chinaIndex][valueField] || dataList[chinaIndex].value || dataList[chinaIndex].session_count || 0;
                    if (valueField === 'user_count' || valueField === 'count') {
                        dataList[chinaIndex][valueField] = (Number(currentValue) || 0) + taiwanTotal;
                    } else if (dataList[chinaIndex].value !== undefined) {
                        dataList[chinaIndex].value = (Number(currentValue) || 0) + taiwanTotal;
                    } else if (dataList[chinaIndex].session_count !== undefined) {
                        dataList[chinaIndex].session_count = (Number(currentValue) || 0) + taiwanTotal;
                    }
                } else {
                    // 如果不存在中国数据，将第一个台湾数据改名为China
                    dataList[taiwanIndices[0]][countryField] = 'China';
                    if (taiwanIndices.length > 1) {
                        // 合并其他台湾数据
                        for (let i = 1; i < taiwanIndices.length; i++) {
                            const val = dataList[taiwanIndices[i]][valueField] || dataList[taiwanIndices[i]].value || dataList[taiwanIndices[i]].session_count || 0;
                            const currentValue = dataList[taiwanIndices[0]][valueField] || dataList[taiwanIndices[0]].value || dataList[taiwanIndices[0]].session_count || 0;
                            if (valueField === 'user_count' || valueField === 'count') {
                                dataList[taiwanIndices[0]][valueField] = (Number(currentValue) || 0) + (Number(val) || 0);
                            } else if (dataList[taiwanIndices[0]].value !== undefined) {
                                dataList[taiwanIndices[0]].value = (Number(currentValue) || 0) + (Number(val) || 0);
                            } else if (dataList[taiwanIndices[0]].session_count !== undefined) {
                                dataList[taiwanIndices[0]].session_count = (Number(currentValue) || 0) + (Number(val) || 0);
                            }
                        }
                    }
                    // 移除其他台湾数据（从后往前删除以保持索引有效）
                    for (let i = taiwanIndices.length - 1; i > 0; i--) {
                        dataList.splice(taiwanIndices[i], 1);
                    }
                    return dataList;
                }

                // 移除所有台湾数据（从后往前删除以保持索引有效）
                for (let i = taiwanIndices.length - 1; i >= 0; i--) {
                    dataList.splice(taiwanIndices[i], 1);
                }
            }

            return dataList;
        },

        async fetchUserStats() {
            try {
                this.loading = true;
                const response = await axios.post('/api/user/GetUserStatistics/');

                if (response.data.code === "123123132") {
                    this.userStatsData = response.data;
                    // 合并台湾数据到中国
                    if (this.userStatsData && this.userStatsData.data) {
                        this.userStatsData.data = this.mergeTaiwanToChina(this.userStatsData.data, 'country', 'user_count');
                    }
                    console.log('用户统计数据获取成功:', this.userStatsData);
                } else {
                    console.error('获取用户统计数据失败:', response.data.msg);
                    // 使用假数据作为后备
                    this.userStatsData = null;
                }
            } catch (error) {
                console.error('用户统计数据API请求失败:', error);
                // 使用假数据作为后备
                this.userStatsData = null;
            } finally {
                this.loading = false;
            }
        },

        async fetchSessionStats() {
            try {
                const response = await axios.post('/api/session/GetSessionStatistics/');

                if (response.data.code === "123123132") {
                    this.sessionStatsData = response.data;
                    // 合并台湾数据到中国
                    if (this.sessionStatsData && this.sessionStatsData.data) {
                        this.sessionStatsData.data = this.mergeTaiwanToChina(this.sessionStatsData.data, 'country', 'session_count');
                    }
                    console.log('会话统计数据获取成功:', this.sessionStatsData);
                } else {
                    console.error('获取会话统计数据失败:', response.data.msg);
                    this.sessionStatsData = null;
                }
            } catch (error) {
                console.error('会话统计数据API请求失败:', error);
                this.sessionStatsData = null;
            }
        },

        async fetchTimeSeriesData() {
            try {
                const response = await axios.post('/api/session/GetSessionNumberOrderByTime/');
                
                if (response.data.code === "123123132") {
                    this.timeSeriesData = response.data;
                    console.log('时间序列数据获取成功:', this.timeSeriesData);
                } else {
                    console.error('获取时间序列数据失败:', response.data.msg);
                    this.timeSeriesData = null;
                }
            } catch (error) {
                console.error('时间序列数据API请求失败:', error);
                this.timeSeriesData = null;
            }
        },

        async initTime() {
            var myChart = this.$echarts.init(document.getElementById("time"), null, { renderer: 'svg' });
            
            // 使用从API获取的时间序列数据
            var data = [];
            
            if (this.timeSeriesData && this.timeSeriesData.data) {
                data = this.timeSeriesData.data.map(item => {
                    // 标准化日期到当天的开始时间（00:00:00）
                    const date = new Date(item.date);
                    const normalizedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                    return [normalizedDate.getTime(), item.session_count];
                });
            } else {
                // 假数据作为后备
                const date = new Date("2015-02-24");
                const normalizedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                data = [[normalizedDate.getTime(), 207]];
            }
            var option = {
                        title: {
                            text: '',
                            left: 'center',
                            top: '3%'
                        },
                        graphic: [
                            {
                                type: 'text',
                                left: 'center',
                                top: '10%',
                                style: {
                                    text: `Session Timeline (N=${this.totalSessions})`,
                                    fontSize: 14,
                                    fontWeight: 'bold',
                                    fill: '#333',
                                    textAlign: 'center'
                                }
                            }
                        ],
                        tooltip: {
                            trigger: 'axis',
                            formatter: function(params) {
                                if (params && params[0]) {
                                    const date = new Date(params[0].value[0]);
                                    const sessionCount = params[0].value[1];
                                    return `Date: ${date.toLocaleDateString()}<br/>Sessions: ${sessionCount}`;
                                }
                                return '';
                            }
                        },
                        grid: {
                            left: '3%',
                            right: '3%',
                            bottom: '15%',
                            top: '15%',
                            containLabel: true
                        },
                        xAxis: {
                            type: 'time',
                            name: 'Data',
                            nameLocation: 'middle',
                            nameGap: 30,
                            nameTextStyle: {
                                fontSize: 14,
                                fontWeight: 'bold'
                            },
                            show: true,
                            axisLabel: {
                                formatter: function(value) {
                                    const date = new Date(value);
                                    return date.toLocaleDateString();
                                }
                            },
                            axisTick: {
                                alignWithLabel: true
                            },
                            splitLine: {
                                show: false
                            }
                        },
                        yAxis: {
                            show: true,
                            type: 'value',
                            name: 'Number of Sessions',
                            nameLocation: 'middle',
                            nameGap: 50,
                            nameTextStyle: {
                                fontSize: 14,
                                fontWeight: 'bold'
                            },
                            nameRotate: 90,
                            axisLabel: {
                                show: true,
                                formatter: function(value) {
                                    return value.toFixed(0);
                                }
                            },
                            axisLine: {
                                show: true
                            },
                            axisTick: {
                                show: true
                            },
                            splitLine: {
                                show: true,
                                lineStyle: {
                                    color: '#e0e0e0',
                                    type: 'dashed'
                                }
                            },
                            minInterval: 1,
                            splitNumber: 5,
                            scale: false  // 禁用y轴缩放
                        },


                        dataZoom: [
                            {
                                type: 'slider',
                                xAxisIndex: 0,
                                yAxisIndex: 'none',
                                bottom: 10,
                                height: 20,
                                borderColor: '#ccc',
                                fillerColor: 'rgba(167,183,204,0.4)',
                                handleStyle: {
                                    color: '#75ABE9'
                                },
                                moveOnMouseMove: true,
                                moveOnMouseWheel: true,
                                preventDefaultMouseMove: true,
                                zoomLock: false,
                                throttle: 100
                            },
                            {
                                type: 'inside',
                                xAxisIndex: 0,
                                yAxisIndex: 'none',
                                moveOnMouseMove: true,
                                moveOnMouseWheel: true,
                                preventDefaultMouseMove: true,
                                zoomLock: false,
                                throttle: 100
                            }
                        ],
                        series: {
                            name: 'Sessions',
                            type: 'line',
                            data: data,
                            label: {
                                show: false
                            },
                            lineStyle: {
                                color: '#75ABE9',
                                width: 2
                            },
                            itemStyle: {
                                color: '#75ABE9'
                            },
                            symbol: 'circle',
                            symbolSize: 10,  // 默认就是放大的状态
                            smooth: false,  // 禁用平滑曲线，确保数据点精确对齐
                            emphasis: {
                                itemStyle: {
                                    color: '#75ABE9',
                                    borderColor: '#75ABE9',
                                    borderWidth: 1
                                },
                                symbol: 'circle',
                                symbolSize: 10  // 悬浮时保持相同大小
                            }
                        }
                    }
            option && myChart.setOption(option);
        },
        initChart() {
            var myChart = this.$echarts.init(document.getElementById("main"), null, { renderer: 'svg' });

            // 准备21个区分度高的颜色
            const distinctColors = [
                '#FF6B6B', // 红色
                '#4ECDC4', // 青绿色
                '#45B7D1', // 天蓝色
                '#FFA07A', // 浅橙色
                '#98D8C8', // 薄荷绿
                '#F7DC6F', // 黄色
                '#BB8FCE', // 紫色
                '#85C1E2', // 浅蓝色
                '#F8B88B', // 桃色
                '#52B788', // 深绿色
                '#E63946', // 深红色
                '#457B9D', // 钢蓝色
                '#FFB703', // 金橙色
                '#E76F51', // 橙红色
                '#06FFA5', // 荧光绿
                '#D4A5A5', // 玫瑰粉
                '#9381FF', // 紫罗兰
                '#FFD60A', // 亮黄色
                '#00B4D8', // 青色
                '#F72585', // 洋红色
                '#8E8E93'  // 灰色 (用于Other)
            ];

            // 使用从API获取的数据或假数据作为后备
            var chartData;
            var chartTitle = 'Users';

            if (this.userStatsData && this.userStatsData.data) {
                // 使用新的字段 user_count；兼容旧字段 count
                const rawList = this.userStatsData.data.map(item => ({
                    value: Number(item.user_count ?? item.count) || 0,
                    name: item.country
                }));
                // 计算已知合计
                const knownTotal = rawList.reduce((sum, it) => sum + it.value, 0);
                const hasOtherInData = rawList.some(it => String(it.name).toLowerCase() === 'other');
                // 如果后端提供 total_users，并且数据中没有 other 且存在差额，则自动补齐 Other
                if (typeof this.userStatsData.total_users === 'number' && !hasOtherInData) {
                    const missing = this.userStatsData.total_users - knownTotal;
                    if (missing > 0) {
                        rawList.push({ name: 'Other', value: missing });
                    }
                }
                chartData = rawList;
            } else {
                // 假数据作为后备
                chartData = [
                    { value: 1200, name: 'United States' },
                    { value: 950, name: 'China' },
                    { value: 300, name: 'Germany' },
                    { value: 1250, name: 'Other' }
                ];
            }

            // 找出最大值的国家索引
            let maxValueIndex = -1;
            let maxValue = -1;
            chartData.forEach((item, index) => {
                if (String(item.name).toLowerCase() !== 'other' && item.value > maxValue) {
                    maxValue = item.value;
                    maxValueIndex = index;
                }
            });

            // 为每个数据项分配颜色
            chartData.forEach((item, index) => {
                // 如果是Other，使用最后一个颜色(灰色)
                if (String(item.name).toLowerCase() === 'other') {
                    item.itemStyle = { color: distinctColors[20] };
                }
                // 如果是最大值的国家，使用特殊颜色 #4B90E2
                else if (index === maxValueIndex) {
                    item.itemStyle = { color: '#4B90E2' };
                }
                else {
                    item.itemStyle = { color: distinctColors[index % 20] };
                }
            });

            // 判断是否需要两列布局(超过11个国家)
            const needTwoColumns = chartData.length > 11;

            var option = {
                title: {
                    text: `${chartTitle} (N=${this.totalUsers})`,
                    left: '53%', // 与图表中心位置保持一致
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 'bold'
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: params => `${params.name}: ${params.value} (${params.percent}%)`
                },
                legend: needTwoColumns ? {
                    type: 'scroll',
                    orient: 'vertical',
                    left: '2%',
                    top: 'middle',
                    height: '90%',
                    pageButtonPosition: 'end',
                    pageIconSize: 12,
                    pageTextStyle: {
                        fontSize: 10
                    }
                } : {
                    orient: 'vertical',
                    left: '6%',
                    top: 'middle'
                },
                color: distinctColors,
                series: [
                    {
                        name: 'Total Users',
                        type: 'pie',
                        radius: '50%',
                        center: ['60%', '50%'], // 向右移动图表，原本默认是 ['50%', '50%']
                        data: chartData,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },
                        label: {
                            fontSize: 11
                        }
                    }
                ]
            };
            option && myChart.setOption(option);
        },
        async initChart2() {

            var myChart = this.$echarts.init(document.getElementById("main2"), null, { renderer: 'canvas' });
            
            // 加载世界地图数据
            try {
                const worldMapData = await this.loadWorldMapData();
                this.$echarts.registerMap('world', worldMapData);
            } catch (error) {
                console.error('加载世界地图数据失败:', error);
                this.registerSimpleWorldMap();
            }
            
            // 设置图表配置
            this.setupChart2(myChart);
        },

        setupChart2(myChart) {
            // 名称标准化：将API中的国家名映射为地图数据里的区域名
            const normalizeCountryName = (name) => {
                const map = {
                    'United States': 'USA',
                    'United States of America': 'USA',
                    'Russia': 'Russia',
                    'South Korea': 'Korea',
                    'North Korea': 'Dem. Rep. Korea',
                    'Vietnam': 'Viet Nam',
                    'Czech Republic': 'Czechia',
                    'Laos': 'Lao PDR',
                    'Syria': 'Syrian Arab Republic',
                    'Iran': 'Iran',
                    'Macedonia': 'North Macedonia',
                    'Ivory Coast': "Côte d'Ivoire",
                    'Cape Verde': 'Cabo Verde',
                    'Swaziland': 'Eswatini',
                    'United Kingdom': 'UK',
                    'Tanzania': 'United Republic of Tanzania',
                    // 将所有台湾相关名称映射到中国
                    'Taiwan': 'China',
                    'Taiwan, China': 'China',
                    'Chinese Taipei': 'China',
                    'Taiwan Province of China': 'China',
                    'Republic of China': 'China',
                };
                return map[name] || name;
            };

            // 使用从API获取的会话统计数据，构造成{name, value}形式用于着色
            let mapData = [];

            if (this.sessionStatsData && this.sessionStatsData.data) {
                mapData = this.sessionStatsData.data.map(item => ({
                    name: normalizeCountryName(item.country),
                    value: Number(item.session_count) || 0
                }));
            } else {
                // 假数据作为后备
                mapData = [
                    { name: 'China', value: 150 },
                    { name: 'USA', value: 100 },
                    { name: 'Russian Federation', value: 80 },
                    { name: 'Brazil', value: 70 },
                    { name: 'India', value: 60 },
                    { name: 'Germany', value: 50 },
                    { name: 'Japan', value: 40 },
                    { name: 'Australia', value: 30 }
                ];
            }

            // 确保台湾和中国显示相同的颜色
            const chinaData = mapData.find(item => item.name === 'China');
            if (chinaData) {
                // 为台湾添加与中国相同的数据值，确保地图上显示相同颜色
                // 地图JSON中台湾的名称是"Taiwan"
                if (!mapData.find(item => item.name === 'Taiwan')) {
                    mapData.push({ name: 'Taiwan', value: chinaData.value });
                }
            }

            // 计算最小值和最大值用于视觉映射
            const values = mapData.map(d => d.value);
            const minVal = Math.min(...values, 0);
            const maxVal = Math.max(...values, 1);
            
            // 创建世界地图配置 - 按国家块填充颜色（红色深浅），并裁剪经纬度范围减少左右留白
            var option = {
                title: {
                    text: `Total Sessions (N=${this.totalSessions})`,
                    left: 'center',
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 'bold'
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: function(params) {
                        // 处理没有数据的国家，显示为0而不是NaN
                        const value = typeof params.value === 'number' && !isNaN(params.value) ? params.value : 0;
                        // 将台湾区域显示为China
                        const displayName = params.name === 'Taiwan' ? 'China' : params.name;
                        return `${displayName}<br/>Sessions: ${value}`;
                    }
                },
                visualMap: {
                    min: minVal,
                    max: maxVal,
                    orient: 'vertical',
                    left: '5%',
                    bottom: 20,
                    calculable: true,
                    inRange: {
                        color: ['#fff1f0', '#ffa39e', '#ff4d4f', '#a8071a']
                    },
                    text: ['High', 'Low']
                },
                series: [
                    {
                        name: 'Sessions',
                        type: 'map',
                        map: 'world',
                        roam: false,
                        aspectScale: 0.75, // 锁定地图的宽高比，防止拉伸变形
                        // 通过限制可视经纬度范围来减少两侧留白（去掉远端小岛影响）
                        boundingCoords: [[-170, 85], [170, -55]],
                        left: '10%',
                        right: '10%',
                        top: 20,
                        bottom: 10,
                        zoom: 1,
                        itemStyle: {
                            areaColor: '#f8faff',
                            borderColor: '#4a90e2',
                            borderWidth: 1
                        },
                        emphasis: {
                            label: { show: false },
                            itemStyle: { areaColor: '#ff7875' }
                        },
                        data: mapData
                    }
                ]
            };
            
            option && myChart.setOption(option, true); // 强制重新渲染
        },

        async loadWorldMapData() {
            // 使用本地的世界地图数据
            const response = await fetch('/world.json');
            if (!response.ok) {
                throw new Error('Failed to load world map data');
            }
            return await response.json();
        },

        registerSimpleWorldMap() {
            // 备用的简化世界地图
            if (!this.$echarts.getMap('world')) {
                this.$echarts.registerMap('world', {
                    type: "FeatureCollection",
                    features: [
                        {
                            type: "Feature",
                            properties: { name: "China" },
                            geometry: { 
                                type: "Polygon", 
                                coordinates: [[[73, 18], [134, 18], [134, 53], [73, 53], [73, 18]]] 
                            }
                        },
                        {
                            type: "Feature", 
                            properties: { name: "United States" },
                            geometry: { 
                                type: "MultiPolygon", 
                                coordinates: [
                                    [[[-125, 20], [-66, 20], [-66, 49], [-125, 49], [-125, 20]]],
                                    [[[-178, 51], [-130, 51], [-130, 71], [-178, 71], [-178, 51]]]
                                ]
                            }
                        },
                        {
                            type: "Feature",
                            properties: { name: "Russia" },
                            geometry: { 
                                type: "Polygon", 
                                coordinates: [[[19, 41], [169, 41], [169, 81], [19, 81], [19, 41]]] 
                            }
                        },
                        {
                            type: "Feature",
                            properties: { name: "Canada" },
                            geometry: { 
                                type: "Polygon", 
                                coordinates: [[[-140, 42], [-52, 42], [-52, 83], [-140, 83], [-140, 42]]] 
                            }
                        },
                        {
                            type: "Feature",
                            properties: { name: "Brazil" },
                            geometry: { 
                                type: "Polygon", 
                                coordinates: [[[-73, -33], [-34, -33], [-34, 5], [-73, 5], [-73, -33]]] 
                            }
                        },
                        {
                            type: "Feature",
                            properties: { name: "Australia" },
                            geometry: { 
                                type: "Polygon", 
                                coordinates: [[[113, -43], [153, -43], [153, -10], [113, -10], [113, -43]]] 
                            }
                        },
                        {
                            type: "Feature",
                            properties: { name: "India" },
                            geometry: { 
                                type: "Polygon", 
                                coordinates: [[[68, 7], [97, 7], [97, 35], [68, 35], [68, 7]]] 
                            }
                        },
                        {
                            type: "Feature",
                            properties: { name: "Germany" },
                            geometry: { 
                                type: "Polygon", 
                                coordinates: [[[5, 47], [15, 47], [15, 55], [5, 55], [5, 47]]] 
                            }
                        },
                        {
                            type: "Feature",
                            properties: { name: "United Kingdom" },
                            geometry: { 
                                type: "Polygon", 
                                coordinates: [[[-8, 50], [2, 50], [2, 61], [-8, 61], [-8, 50]]] 
                            }
                        },
                        {
                            type: "Feature",
                            properties: { name: "Japan" },
                            geometry: { 
                                type: "Polygon", 
                                coordinates: [[[129, 30], [146, 30], [146, 46], [129, 46], [129, 30]]] 
                            }
                        },
                        {
                            type: "Feature",
                            properties: { name: "France" },
                            geometry: { 
                                type: "Polygon", 
                                coordinates: [[[-5, 42], [8, 42], [8, 51], [-5, 51], [-5, 42]]] 
                            }
                        },
                        {
                            type: "Feature",
                            properties: { name: "South Africa" },
                            geometry: { 
                                type: "Polygon", 
                                coordinates: [[[16, -35], [33, -35], [33, -22], [16, -22], [16, -35]]] 
                            }
                        }
                    ]
                });
            }
        }

    },
    async mounted() {
        // 获取所有数据
        await this.fetchUserStats();
        await this.fetchSessionStats();
        await this.fetchTimeSeriesData();

        // 初始化图表
        await this.initChart()
        await this.initChart2()
        await this.initTime()

        // 添加窗口大小变化监听,确保地图响应式调整
        this.handleResize = () => {
            const chart2 = this.$echarts.getInstanceByDom(document.getElementById("main2"));
            if (chart2) {
                chart2.resize();
            }
            const chart1 = this.$echarts.getInstanceByDom(document.getElementById("main"));
            if (chart1) {
                chart1.resize();
            }
            const timeChart = this.$echarts.getInstanceByDom(document.getElementById("time"));
            if (timeChart) {
                timeChart.resize();
            }
        };
        window.addEventListener('resize', this.handleResize);
    },
    beforeUnmount() {
        // 清理事件监听器
        if (this.handleResize) {
            window.removeEventListener('resize', this.handleResize);
        }
    }
};
</script>

<style scoped>
/* 默认(桌面模式,md及以上): 固定400px高度,与饼图一致 */
.map-container {
    width: 100%;
    height: 400px;
}

.map-container #main2 {
    width: 100%;
    height: 100%;
}

/* 手机模式(md以下,纵向排列): 使用比例布局,保持地图比例 */
@media (max-width: 959px) {
    .map-container {
        position: relative;
        width: 100%;
        height: 0;
        padding-bottom: 50%; /* 保持 2:1 的宽高比 */
    }

    .map-container #main2 {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
}
</style>